import * as tslib_1 from "tslib";
import xamatron from "xamatron";
import { Vue } from "vue-property-decorator";
function unsigned(n) {
    return n >>> 0;
}
function signed(bits, n) {
    return (bits == 32)
        ? n >> 0
        : (n & (1 << (bits - 1))
            ? n | -(1 << bits)
            : n);
}
var AlluScanner = /** @class */ (function () {
    function AlluScanner() {
        var _this = this;
        this.supported = false;
        this.scanning = false;
        this.sensors = [];
        this.scanCallback = null;
        this.supported = xamatron.enabled && /\bbluetooth\b/.test(xamatron.queryString.features || "");
        if (!this.supported)
            return;
        xamatron.bridge.addHandler("bluetooth.onLeScan", function (msg) {
            if (!(msg.name && msg.advertisementRecords))
                return;
            var data = msg.advertisementRecords[0xff];
            if (!(data && data.length == 8))
                return;
            var sensor = _this.sensors.find(function (d) { return d.deviceId === msg.deviceId; });
            var found = !!sensor;
            if (!sensor)
                sensor = { deviceId: msg.deviceId };
            sensor.serial = msg.name;
            sensor.rssi = msg.rssi;
            sensor.timestamp = new Date(unsigned((data[0] << 24) | (data[1] << 16) | (data[2] << 8) | data[3]) * 1000);
            sensor.runtime = (data[4] << 8) | data[5];
            sensor.temperature = signed(8, data[6]);
            sensor.batteryLevel = data[7];
            if (!found)
                _this.sensors.push(sensor);
            if (_this.scanCallback)
                _this.scanCallback(sensor);
        });
    }
    AlluScanner.prototype.scan = function (scanTimeout) {
        if (scanTimeout === void 0) { scanTimeout = 20 * 1000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.supported)
                            throw { code: "BLE_NOT_AVAILABLE", message: "Xamatron is not enabled." };
                        this.sensors.splice(0, this.sensors.length);
                        console.log("- LE scan-");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.scanning = true;
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.leScan", { scanTimeout: scanTimeout })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.log("CODE: " + err_1.code + " MSG: " + err_1.message);
                        return [3 /*break*/, 5];
                    case 4:
                        this.scanning = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AlluScanner.prototype.cancelScan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.supported)
                            return [2 /*return*/];
                        console.log("-cancel LE scan-");
                        this.scanning = false;
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.cancelLeScan", {})];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AlluScanner.prototype.connect = function (sensor, attemptCallback) {
        if (attemptCallback === void 0) { attemptCallback = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var attempt, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.supported)
                            throw { code: "BLE_NOT_AVAILABLE", message: "Xamatron is not enabled." };
                        attempt = 1;
                        _a.label = 1;
                    case 1:
                        if (!(attempt < 5)) return [3 /*break*/, 6];
                        if (attemptCallback)
                            attemptCallback(attempt);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattConnect", { deviceId: sensor.deviceId })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, new AlluSensorConnection(sensor.deviceId)];
                    case 4:
                        err_2 = _a.sent();
                        if (err_2.code === "BLE_NOT_AVAILABLE" || err_2.code == "BLE_NOT_ENABLED")
                            throw err_2;
                        return [3 /*break*/, 5];
                    case 5:
                        attempt++;
                        return [3 /*break*/, 1];
                    case 6: throw { code: "CONNECTION_FAILED", message: "Failed to connect to device." };
                }
            });
        });
    };
    AlluScanner.prototype.findBySerial = function (serial) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sensor;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.supported)
                            throw { code: "BLE_NOT_AVAILABLE", message: "Xamatron is not enabled." };
                        this.scanCallback = function (device) {
                            if (device.serial === serial)
                                _this.cancelScan();
                        };
                        return [4 /*yield*/, this.scan(20 * 1000)];
                    case 1:
                        _a.sent();
                        this.scanCallback = null;
                        sensor = this.sensors.find(function (d) { return d.serial && d.serial.toUpperCase() === serial.toUpperCase(); });
                        if (!sensor)
                            throw { code: "DEVICE_NOT_FOUND", message: "Device not found." };
                        return [2 /*return*/, sensor];
                }
            });
        });
    };
    return AlluScanner;
}());
export { AlluScanner };
var SERVICE_STATUS = "5f16e4d7-4143-4ec8-8a9e-9087d066e928";
var CHAR_STATUS_RUNTIME = "c3c15fef-6efa-4d9f-8441-8d2be41b5ef6";
var SERVICE_ACCELEROMETER = "39555b37-081e-4cdd-89dd-79da12377134";
var CHAR_ACCELEROMETER_DATA = "0449d9d9-ef37-48c7-b83d-6cca8cd93fee";
var SERVICE_SETTINGS = "45bca4e3-8c67-4944-8d69-ac51fc0b8319";
var CHAR_SETTINGS_ACC_MODE = "049b7cdc-1533-4c97-9ca9-7909b8d107ba";
var SERVICE_MEMORY = "b3d34021-7ca8-4dc2-9bfa-14636fd9a263";
var CHAR_MEMORY_RBTRIGGER = "0b85cf35-e2d3-479d-bf28-58894c47d354";
var CHAR_MEMORY_RBDATA = "c7ee758b-009d-4427-8ffb-2352b04d3a2a";
var CHAR_MEMORY_ENTRYCNT = "4e9c9283-380b-43cf-ba4b-2bdbbc42cfc8";
var AlluSensorConnection = /** @class */ (function () {
    function AlluSensorConnection(deviceId) {
        var _this = this;
        this.deviceId = deviceId;
        this.notificationCallbacks = {};
        this.onNotifyBound = function (data) { return _this.onNotify(data); };
        xamatron.bridge.addHandler("bluetooth.gattOnNotify", this.onNotifyBound);
    }
    AlluSensorConnection.prototype.dispose = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xamatron.bridge.removeHandler("bluetooth.gattOnNotify", this.onNotifyBound);
                        return [4 /*yield*/, this.disableTelemetry()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattDisconnect", { deviceId: this.deviceId })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AlluSensorConnection.prototype.enableTelemetry = function (timeout, callback) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var expires;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        expires = 0;
                        this.setNotificationCallback(SERVICE_ACCELEROMETER, CHAR_ACCELEROMETER_DATA, function (value) {
                            var FACTOR = 0.00006;
                            callback({
                                timeLeft: Math.floor((expires - Date.now()) / 1000),
                                timestamp: unsigned((value[0] << 24) | (value[1] << 16) | (value[2] << 8) | value[3]),
                                measurementId: value[4],
                                x: signed(16, (value[5] << 8) | value[6]) * FACTOR,
                                y: signed(16, (value[7] << 8) | value[8]) * FACTOR,
                                z: signed(16, (value[9] << 8) | value[10]) * FACTOR,
                                pulses: unsigned((value[11] << 8) | value[12]),
                                temperature: signed(8, value[13]),
                            });
                        });
                        return [4 /*yield*/, this.write(SERVICE_SETTINGS, CHAR_SETTINGS_ACC_MODE, [Math.min(0xf0, timeout)])];
                    case 1:
                        _a.sent();
                        expires = Date.now() + timeout * 1000;
                        this.telemetryTimeout = setTimeout(function () { return callback(null); }, timeout * 1000);
                        return [2 /*return*/];
                }
            });
        });
    };
    AlluSensorConnection.prototype.disableTelemetry = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.telemetryTimeout) {
                            clearTimeout(this.telemetryTimeout);
                            this.telemetryTimeout = null;
                        }
                        console.log("disable telemetry setNotificationCallback");
                        return [4 /*yield*/, this.setNotificationCallback(SERVICE_ACCELEROMETER, CHAR_ACCELEROMETER_DATA, null)];
                    case 1:
                        _a.sent();
                        console.log("disable telemetry write");
                        return [4 /*yield*/, this.write(SERVICE_SETTINGS, CHAR_SETTINGS_ACC_MODE, [0])];
                    case 2:
                        _a.sent();
                        console.log("disable telemetry finished");
                        return [2 /*return*/];
                }
            });
        });
    };
    AlluSensorConnection.prototype.readLog = function (progressCallback) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var timeout, totalCountValue, totalCount, data, count;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timeout = new Timeout();
                        timeout.set(10 * 1000);
                        return [4 /*yield*/, this.read(SERVICE_MEMORY, CHAR_MEMORY_ENTRYCNT)];
                    case 1:
                        totalCountValue = _a.sent();
                        totalCount = (totalCountValue[1] << 8 | totalCountValue[0]);
                        data = [];
                        count = 0;
                        return [4 /*yield*/, this.setNotificationCallback(SERVICE_MEMORY, CHAR_MEMORY_RBDATA, function (value) {
                                timeout.set(1000);
                                if (value.find(function (b) { return b != 0; })) {
                                    var timestamp = unsigned((value[0] << 24) | (value[1] << 16) | (value[2] << 8) | value[3]);
                                    data.push({
                                        timestamp: new Date(timestamp * 1000).toISOString(),
                                        runtime: unsigned((value[5] << 8) | value[4]),
                                        buckets: unsigned((value[9] << 24) | (value[8] << 16) | (value[7] << 8) | value[6]),
                                        drumRuntime: unsigned((value[13] << 24) | (value[12] << 16) | (value[11] << 8) | value[10]),
                                        temperature: signed(8, value[14]),
                                        batteryLevel: value[15],
                                    });
                                }
                                count++;
                                progressCallback(totalCount != 0 ? Math.floor(count / totalCount * 100) : 100);
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.write(SERVICE_MEMORY, CHAR_MEMORY_RBTRIGGER, [1])];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, timeout.promise];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.setNotificationCallback(SERVICE_MEMORY, CHAR_MEMORY_RBDATA, null)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AlluSensorConnection.prototype.read = function (serviceGuid, characteristicGuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattReadCharacteristic", {
                            deviceId: this.deviceId, serviceGuid: serviceGuid, characteristicGuid: characteristicGuid
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AlluSensorConnection.prototype.write = function (serviceGuid, characteristicGuid, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattWriteCharacteristic", {
                                deviceId: this.deviceId, serviceGuid: serviceGuid, characteristicGuid: characteristicGuid, value: value
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AlluSensorConnection.prototype.setNotificationCallback = function (serviceGuid, characteristicGuid, callback) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var key, err_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = (serviceGuid + " " + characteristicGuid).toLowerCase();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!callback) return [3 /*break*/, 3];
                        this.notificationCallbacks[key] = callback;
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattEnableNotify", {
                                deviceId: this.deviceId, serviceGuid: serviceGuid, characteristicGuid: characteristicGuid,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        delete this.notificationCallbacks[key];
                        return [4 /*yield*/, xamatron.bridge.invoke("bluetooth.gattDisableNotify", {
                                deviceId: this.deviceId, serviceGuid: serviceGuid, characteristicGuid: characteristicGuid,
                            })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        console.log(err_4);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AlluSensorConnection.prototype.onNotify = function (data) {
        var key = (data.serviceGuid + " " + data.characteristicGuid).toLowerCase();
        var callback = this.notificationCallbacks[key];
        if (callback)
            callback(data.value);
    };
    return AlluSensorConnection;
}());
export { AlluSensorConnection };
var Timeout = /** @class */ (function () {
    function Timeout() {
        var _this = this;
        this.promise = new Promise(function (resolve) {
            _this.resolvePromise = resolve;
        });
    }
    Timeout.prototype.set = function (timeoutMs) {
        if (this.timeout)
            clearTimeout(this.timeout);
        this.timeout = setTimeout(this.resolvePromise, timeoutMs);
    };
    return Timeout;
}());
export var scanner = Vue.observable(new AlluScanner());
